<script setup>
const route = useRoute();

import singleevent from "../assets/gql/event.gql";
import partnersQuery from "../assets/gql/partners.gql";
const { data:partners } = await useAsyncQuery(partnersQuery);
const { data } = await useAsyncQuery(singleevent, { slug: route.params.slug });
const event = ref(data.value.eventBySlug);

const ctas = 
  {
    link: event.value.registration_link,
    type: "REGISTRACE",
  }
;

function formatTime(input) {
  const [hours, minutes] = input.split(":");
  return `${hours}:${minutes}`;
}

function formatDate(dateString) {
  const [year, month, day] = dateString?.split("-");
  return `${parseInt(day)}. ${parseInt(month)}. ${parseInt(year)}`;
}
</script>

<template>
  <div>
    <Menu />
    <div class="event-container">
      <div
        class="half half-color"
      >
        <div class="flex content-box sticky text-container"         :style="{ 'background-color': event?.targets[0]?.color || '#e9a9a8', 'color': useContrastColor(event?.targets[0]?.color || 'white') }"
        >
          <div>
 
            <h3>{{ event.name }}</h3>
          </div>
  
          <div class="flex-between registration-content">           
            <div>
              <div class="instruction">
                <p>Organizátor</p>
                <p>
                  <b>{{ event.organiser.name }}</b>
                </p>
              </div>
              <div class="instruction">
                <p>Termín</p>
                <p>
                  <b
                    >{{ formatDate(event.term) }} od {{ formatTime(event.start_time) }} do
                    {{ formatTime(event.end_time) }}</b
                  >
                </p>
              </div>
              <div class="instruction">
                <p>Místo</p>
                <p>
                  <b
                    >{{ event.location.name }},
                    {{ event.location.address }},
                    {{ event.location.city.name }}</b
                  >
                </p>
              </div>
              <div class="instruction">
                <p>Typ akce</p>
                <p>
                  <b class="white" v-for="(format, index) in event.formats">
                    {{ format.name }}<span v-if="index < event.formats.length - 1">, </span> 
                  </b>
                </p>
              </div>
            </div>
            
            <div v-if="event.registration_link" class="socials">
              <ButtonWithArrow :cta="ctas" />
            </div>
          </div>
        </div>
      </div>

      <div class="half">

        <div class="text-container">
          <div class="flex flex-wrap">
            <button class="white" v-for="target in event.targets">
              {{ target.name }}
            </button>
            <button class="white" v-for="format in event.formats">
              {{ format.name }}
            </button>
            <button class="white" v-for="language in event.languages">
              {{ language }}
            </button>
          </div>
          <h3>Program</h3>
          <p v-for="item in event.program" class="program">
            <h4>{{ item.start_time }}-{{ item.end_time }}</h4>
            <h3 class="program-title">{{ item.name }}</h3>
            <div v-html="item.content"></div>
            <p class="small-font">{{ item.speaker }}</p>
          </p>
        
          <div v-html="event.content"></div>
        </div>

        <div class="text-container bg-black content-box">
          <h3 class="max400">Kontakt na pořadatele akce</h3>
          <div>
            <div
              v-for="social in event.organiser.social_networks"
              class="socials"
            >
              <ButtonWithArrow :cta="social" :white="true" />
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- <Logos title="Partneři akce" :items="event.partners" v-if="event.partners.length > 0" /> -->
    <Logos title="Dny AI 2024" :items="partners.partners"/>
    <Footer />
  </div>
</template>

<style lang="scss">
$menu: 140px;
.event-container {
  padding-top: 12.5vw;
  @media (max-width:1000px) {
    padding-top: $menu;
    
  }
  display: flex;
  @media (max-width:991px) {
    display: block;
    
  }
}
.uppercase {
  text-transform: uppercase;
}
.socials {
  margin-top: 12px;
  margin-bottom: 12px;
}
.center {
  text-align: center;
}
.category {
  margin-bottom: -0.5rem;
  font-size: 1.25rem;
}
.registration-content {
  align-items: flex-end;
}
button {
  background-color: transparent;
  border: 1px solid black;
  color: black;
  margin-bottom: 8px;
  margin-right: 8px;
  padding: 8px 12px;
  font-weight: 300;
  font-size: 12px;
  letter-spacing: 0.4px;
}

.small-font {
  font-size: 16px;
}
.program-title {
  font-size: 28px;
}

.program {
  margin-bottom: 64px;
}

.text-container {
  padding: 32px !important;
}

.content-box {
  padding: 32px !important;
  display: flex;
  height: calc(100vh - $menu);
  box-sizing: border-box;
  flex-direction: column;
  justify-content: space-between;
  @media (max-width: 767px) {
    height: auto;
    display: block;
  }

  .instruction {
    margin-top: 20px;

    p {
      margin: 0;
      font-size: 16px;
    }
  }
  button {
    margin-right: 12px;
  }
}
.max400 {
  max-width: 600px;
}
.half {
  @media (max-width: 767px) {
    display: block;
  }
}

.flex {
  @media (max-width: 767px) {
    display: block;
  }
}
.sticky {
  @media (max-width: 991px) {
    position: static;
  }
}

h3 {
  font-size: 2.25rem;
}
</style>
